import { useModal } from '../../../components/useModal'
import { useExportToXLS } from '../../../lib/hooks/useExportToXLS'
import { useCreateSecureUploadLink } from '../../../api/dealership/customers/util/useCreateSecureUploadLink'
import GhostButton from '../../../components/Buttons/GhostButton'
import { startCase } from 'lodash'
import CSVReader from '../../../components/CSVReaderClickAndDragUpload'
import ManualUploadMapper from '../UploadCustomers/ManualUploadMapper'
import { Button } from '@demandlocal/components'
import GenerateSecureLink from '../../../components/CustomersUpload/GenerateSecureLink'
import React from 'react'
import { UseMutationResult } from 'react-query'

import { ReactComponent as IconLock } from './../../../images/icons/icon_lock.svg'
type Props = {
  manualUploadCSVMutation: UseMutationResult<
    unknown,
    unknown,
    { file: File; mapped_columns: unknown; customer_source_id: string },
    unknown
  >
  databaseColumns?: Array<string>
  selectedUploadType:
    | 'sales'
    | 'leads'
    | 'service'
    | 'other'
    | 'hashed-customers'
    | 'opt-out-customers'
}

const SourcePickerManualUpload = (props: Props): JSX.Element => {
  const { manualUploadCSVMutation, databaseColumns, selectedUploadType } = props
  const { handleModal } = useModal()
  const { exportToCSV } = useExportToXLS()
  const { mutateAsync: createSecureUploadLink, isLoading } = useCreateSecureUploadLink()

  return (
    <div
      className={
        'py-10 px-6 rounded-lg font-Spartan flex-1 flex items-center flex-col bg-cultured-gray'
      }>
      <div className={'flex-1 flex flex-col items-center'}>
        <div className={'font-bold text-base'}>Upload Data File</div>
        <div className={'font-medium pt-2  text-xs text-davy-gray'}>
          Accepted formats: CSV (50 mb max)
        </div>
        <GhostButton
          transparent={true}
          onClick={(e) => {
            e.preventDefault()
            exportToCSV(
              [(databaseColumns ?? [])?.map((column) => startCase(column))],
              'dl_saas_template.csv',
              true,
              'csv',
            )
          }}>
          Download CSV Template
        </GhostButton>
      </div>
      <div className={'pt-12 w-full px-6'}>
        <CSVReader
          onFileAccepted={(results, file) => {
            handleModal(
              <ManualUploadMapper
                // @ts-ignore
                data={results}
                file={file}
                manualUploadCSVMutation={manualUploadCSVMutation}
                databaseColumns={databaseColumns}
                selectedUploadType={selectedUploadType}
              />,
            )
          }}
        />
      </div>
      <div className={'mt-4 flex flex-col'}>
        <Button
          variant={'secondary'}
          disabled={isLoading}
          onClick={(e: Event) => {
            e.preventDefault()
            handleModal(<GenerateSecureLink selectedUploadType={selectedUploadType} />)
          }}
          rightSlot={<IconLock className={'stroke-white fill-white'} />}>
          Create a secure one time link
        </Button>
      </div>
    </div>
  )
}
export default SourcePickerManualUpload
